import React from "react";
import "./App.css";

export default function Synonyms(props) {
  console.log(props);
  if (props) {
    if (props.synonyms && props.synonyms.length > 0) {
      return (
        <div className="synonyms">
          <strong className="title-font">Synonyms: </strong>
          <em>
            <ul className="list-inline">
              {props.synonyms.map(function (synonym, index) {
                return (
                  <li className="list-inline-item" key={index}>
                    {synonym}
                  </li>
                );
              })}
            </ul>
          </em>
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
}
